import {Component, effect, inject, Inject, OnDestroy, OnInit, PLATFORM_ID, signal} from '@angular/core';
import {BookingV2ManagerService} from '../../services/booking-v2-manager.service';
import {BookingV2SurveyService} from '../../services/booking-v2-survey.service';
import {BookingV2StateService} from '../../services/booking-v2-state.service';
import {Subscription} from 'rxjs';
import {DOCUMENT, isPlatformBrowser} from '@angular/common';
import {ToolsService} from '../../../../services/tools.service';
import {MyPagesService} from '../../../../services/my-pages.service';
import {BookingV2DataService} from '../../services/booking-v2-data.service';
import {toSignal} from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-submit-section',
  templateUrl: './submit-section.component.html',
  styleUrls: ['./submit-section.component.scss'],
})
export class SubmitSectionComponent implements OnInit, OnDestroy {
  public errorMessage = signal<string>(null);
  public displayBankIdSection = signal<boolean>(false);
  private subscriptions: Subscription[] = [];
  private myPagesService = inject(MyPagesService);
  private profile = toSignal(this.myPagesService.profile$);
  private twoFactorAuthenticationRequired = signal<boolean>(null);

  constructor(
    private bookingManager: BookingV2ManagerService,
    private bookingSurvey: BookingV2SurveyService,
    private bookingState: BookingV2StateService,
    private bookingData: BookingV2DataService,
    private tools: ToolsService,
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject(DOCUMENT) private _document: HTMLDocument,
  ) {
    effect(
      () => {
        if (isPlatformBrowser(this.platformId) && this.twoFactorAuthenticationRequired() === true && this.profile()) {
          this.bookingData.profile$.next(this.profile());
          this.setBankIdSectionVisibility();
        }
      },
      {allowSignalWrites: true},
    );
  }

  public ngOnInit(): void {
    this.setListeners();
  }

  public ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  public sendBooking(): void {
    this.bookingManager.sendBookingTry();

    const onInvalidForm = () => {
      let findedElementId: string = '';
      const errorElements = this._document.querySelectorAll('.ng-invalid');
      errorElements.forEach((element) => {
        if (findedElementId === '' && element.id !== '' && element.id !== 'varden-survey-form') {
          findedElementId = element.id;
        }
      });
      if (findedElementId !== '') {
        this.tools.scrollTo(findedElementId, 500, -24);
      }
    };

    this.bookingManager.sendBooking(
      this.bookingSurvey.surveyForm,
      onInvalidForm,
      this.bookingSurvey.phoneNumberFieldKey,
    );
  }

  private setListeners(): void {
    this.subscriptions.push(
      this.bookingState.state$.subscribe((result) => {
        this.errorMessage.set(result.errorMessage);
        this.twoFactorAuthenticationRequired.set(result.twoFactorAuthenticationRequired);
        this.setBankIdSectionVisibility();
      }),
    );
  }

  private setBankIdSectionVisibility(): void {
    this.displayBankIdSection.set(this.twoFactorAuthenticationRequired() === true && this.profile() === null);
  }
}
